import App from '@/routes/app/template'

export default {
  path: '/:region?/:name?/:lat,:lon,:zoom/:layer?',
  name: 'app',
  icon: 'home-outline',
  nav: true,

  component: App
}



// WEBPACK FOOTER //
// ./src/routes/app/index.js